import { render, staticRenderFns } from "./AdvisorStudents.vue?vue&type=template&id=20b27ff2&"
import script from "./AdvisorStudents.vue?vue&type=script&lang=js&"
export * from "./AdvisorStudents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports